<template>
  <v-dialog v-model="active" width="480" persistent>
    <template v-slot:activator="{ on, attrs }">
      <TextButton large rounded color="secondary" v-on="on" v-bind="attrs"
        ><v-icon class="mr-2">mdi-plus</v-icon> Registrar entrada</TextButton
      >
    </template>
    <v-card color="primary" class="ui-module-card rounded-sm">
      <v-card-title class="ui-module-titlebar">
        <div class="text-h6">Registrar entrada de inventario</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form v-model="movimientoForm" ref="form">
            <v-row>
              <v-col cols="12" align="center">
                <div class="text-subtitle-2 font-weight-bold mb-2">¿De qué elemento realizará el movimiento?</div>
                <v-btn-toggle v-model="elementoMovimiento" color="secondary" mandatory rounded>
                  <v-btn>Cargador</v-btn>
                  <v-btn>Munición</v-btn>
                </v-btn-toggle>
                <v-divider class="my-4"></v-divider>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="ui-form-field"
                  v-model="movimiento.fechaCompra"
                  v-mask="'##/##/####'"
                  hint="Formato de fecha: DD/MM/YYYY"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  :rules="dateRules"
                >
                  <template v-slot:label>Fecha de compra <span class="red--text">*</span> </template>
                </v-text-field>
                <v-text-field
                  class="ui-form-field"
                  v-model="movimiento.puestaDisposición"
                  v-mask="'##/##/####'"
                  hint="Formato de fecha: DD/MM/YYYY"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  :rules="dateRules"
                >
                  <template v-slot:label>Fecha de puesta a disposición <span class="red--text">*</span> </template>
                </v-text-field>
                <v-select
                  class="ui-form-field"
                  v-model="movimiento.fk_idCatCalibre"
                  :items="calibres"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  item-value="id"
                  item-text="title"
                  item-color="secondary"
                  :rules="required"
                >
                  <template v-slot:label>Calibre <span class="red--text">*</span> </template>
                </v-select>
                <v-text-field
                  class="ui-form-field"
                  v-model.number="movimiento.cantidad"
                  type="number"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  min="0"
                  :rules="cantidadRules"
                >
                  <template v-slot:label>Cantidad <span class="red--text">*</span> </template>
                </v-text-field>
                <v-textarea
                  class="ui-form-field"
                  label="Observaciones"
                  v-model="movimiento.observaciones"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  no-resize
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center ui-module-actions">
        <TextButton
          rounded
          color="secondary"
          class="ui-module-btn-solid"
          :loading="loading"
          :disabled="loading || !movimientoForm"
          v-on:click="triggerSaveMovimiento()"
          >Guardar movimiento</TextButton
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  data() {
    return {
      active: false,
      loading: false,
      movimientoForm: false,

      elementoMovimiento: 0,
      movimiento: {
        fk_idCatCalibre: null,
        fk_idcatTipoMovimiento: 1,
        cantidad: 0,
        observaciones: '',
        fechaCompra: null,
        fechaPuestaDispocision: null,
      },

      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],

      required: [(v) => !!v || 'Este campo es requerido'],
      cantidadRules: [(v) => v > 0 || 'La cantidad no puede ser cero.'],
    }
  },

  computed: {
    ...mapGetters('calibre', {
      calibres: 'getCalibres',
    }),

    ...mapGetters('tipoMovimientoEquipamiento', {
      tipoMovimiento: 'getTipoMovimiento',
    }),
  },

  methods: {
    ...mapActions('movimientoMunicion', ['saveMovimientoMunicion', 'fetchMovimientoMunicion']),
    ...mapActions('movimientoCargador', ['saveMovimientoCargador', 'fetchMovimientoCargador']),

    closeDialog() {
      this.loading = false
      this.$refs.form.resetValidation()
      this.movimiento = {
        fk_idCatCalibre: null,
        fk_idcatTipoMovimiento: 1,
        cantidad: 0,
        observaciones: '',
      }
      this.active = false
    },

    async triggerSaveMovimiento() {
      this.loading = true

      if (this.elementoMovimiento == 0) {
        await this.saveMovimientoCargador(this.movimiento)
      } else {
        await this.saveMovimientoMunicion(this.movimiento)
        await this.fetchMovimientoMunicion()
      }

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

::v-deep .ui-module-titlebar {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field textarea,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}
</style>
